<!--
 * @Author: zs
 * @Date: 2022-04-19 09:37:34
 * @LastEditTime: 2022-04-20 15:52:37
 * @Description:
 * @FilePath: \smart-community\src\components\global\HunfoldBox.vue
-->
<template>
  <div class="hunfoldBox">
    <div
      class="headR"
      @click="refreshTable"
    >
      <i
        class="iconfont icon-zhankai "
        @click="unfold"
        :style="{'cursor':'pointer'}"
      ></i>
    </div>
    <div
      class="left"
      @click="onLeft"
    >
      <el-icon>
        <arrow-left-bold />
      </el-icon>
    </div>
    <div class="text">
      <ul :style="{'margin-left':margin1+'px'}">
        <li
          v-for="(item,index) in userList"
          :key="index"
          @mouseover="handleMoreOperation(item, index)"
          @mouseleave="handleMoreLeave(item)"
          @click="openwin(item)"
        >
          <el-checkbox
            v-model="item.checked"
            size="large"
            :style="{'position':'absolute','top':'-12px'}"
          />
          <img
            :src='item.url'
            alt=""
          >
          <div class="top">
            <i
              :class="['iconfont', 'icon-shanchu']"
              :style="{color: item.checked ? '#000': 'white'}"
              v-show="item.id == showEareItem"
            ></i>
          </div>
          <div class="bottom">
            <i
              :class="['iconfont', 'icon-xuanze']"
              :style="{color: item.checked ? '#07ce76':'#000'}"
              v-show="item.id == showEareItem"
            ></i>
          </div>
        </li>
      </ul>
    </div>
    <div
      class="right"
      @click="onRight"
    >
      <el-icon>
        <arrow-right-bold />
      </el-icon>
    </div>
    <div class="footL">
      <p>疑似目标收藏夹 | {{userListLen}}
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >全选</el-checkbox>
      </p>

    </div>
    <div class="footR">
      <h-button
        type="primary"
        @click="details"
      >归档到档案</h-button>
      <h-button type="primary">导出</h-button>
      <h-button type="danger">清空</h-button>
    </div>
    <!-- 归档到档案 -->
    <el-dialog
      v-model="flag"
      width="30%"
      center
      :style="{padding:'10px'}"
      class="dialogX"
    >
      <div class="head">
        <el-button
          type="primary"
          :icon="Plus"
          :style="{'margin-left':'30px'}"
        >
          新建案件
        </el-button>
        <el-input
          v-model="input2"
          class="w-50 m-2"
          placeholder="请输入案件名称"
          :suffix-icon="Search"
          :style="{'width':'280px'}"
        />
      </div>
      <h-table
        ref="tableRef"
        v-model:data="tableData"
        v-model:columns="columns"
        :method="repositorylist"
        :params="tableParams"
        @select="hzTableSelect"
      >
      </h-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="primary"
            @click="submit = false"
          >确定</el-button>
          <el-button @click="centerDialogVisible">取消</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 点击头像打开详情 -->
    <h-detalis
      @changeEmit="openwin()"
      v-show="flag1"
      :userList='userList'
    ></h-detalis>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from "vue-demi";
import {
  ArrowLeftBold,
  ArrowRightBold,
  Plus,
  Search
} from "@element-plus/icons-vue";
export default defineComponent({
  name: "HUnfoldBox",
  components: { ArrowLeftBold, ArrowRightBold },
  props: {},
  setup(props, { emit }) {
    const state = reactive({
      flag1: false,
      columns: [
        {
          label: "案件名称",
          prop: "name"
        },
        {
          label: "创建人",
          prop: "user"
        },
        {
          label: "创建时间",
          prop: "time"
        }
      ],
      tableParams: {},
      tableData: [],
      flag: false,
      checkAll: false,
      moreOperation: false, // 展示更多操作
      showEareItem: false,
      userListLen: 0,
      margin1: 0,
      userList: [
        { id: 1, url: require("@/assets/images/test.png"), checked: false },
        { id: 2, url: require("@/assets/images/test.png"), checked: false },
        { id: 3, url: require("@/assets/images/test.png"), checked: false },
        { id: 4, url: require("@/assets/images/test.png"), checked: false },
        { id: 5, url: require("@/assets/images/test.png"), checked: false },
        { id: 6, url: require("@/assets/images/test.png"), checked: false },
        { id: 8, url: require("@/assets/images/test.png"), checked: false },
        { id: 9, url: require("@/assets/images/test.png"), checked: false },
        { id: 10, url: require("@/assets/images/test.png"), checked: false },
        { id: 11, url: require("@/assets/images/test.png"), checked: false },
        { id: 12, url: require("@/assets/images/test.png"), checked: false },
        { id: 13, url: require("@/assets/images/test.png"), checked: false },
        { id: 14, url: require("@/assets/images/test.png"), checked: false },
        { id: 15, url: require("@/assets/images/test.png"), checked: false },
        { id: 16, url: require("@/assets/images/test.png"), checked: false },
        { id: 17, url: require("@/assets/images/test.png"), checked: false },
        { id: 18, url: require("@/assets/images/test.png"), checked: false },
        { id: 19, url: require("@/assets/images/test.png"), checked: false },
        { id: 20, url: require("@/assets/images/test.png"), checked: false },
        { id: 21, url: require("@/assets/images/test.png"), checked: false },
        { id: 22, url: require("@/assets/images/test.png"), checked: false }
      ]
    });
    const refData = toRefs(state);
    const refreshTable = () => {
      emit("refreshTableEmit");
      state.margin1 = 0;
    };
    // 向左翻页
    const onLeft = () => {
      console.log("向左");
      if (state.margin1 === 0) {
        state.margin1 = 0;
      } else {
        state.margin1 += 50;
      }
    };
    // 向右翻页
    const onRight = () => {
      var listLenth = state.userList.length * 100;
      if (state.margin1 <= -listLenth) {
        state.margin1 = -listLenth;
      } else {
        state.margin1 -= 50;
      }
    };
    // 全选
    const handleCheckAllChange = (val) => {
      state.userList.forEach((item, index) => {
        item.checked = !item.checked;
        if (item.checked === false) {
          state.checkAll = false;
        }
      });
      console.log(val, 88888);
    };
    // 获取数据长度
    const getLenth = () => {
      state.userListLen = state.userList.length + 1;
      console.log(state.userListLen, 77777);
    };
    // 鼠标移入显示
    const handleMoreOperation = (item) => {
      state.showEareItem = item.id;
    };
    // 鼠标移出隐藏
    const handleMoreLeave = () => {
      state.showEareItem = false;
    };
    // 点击归档到档案
    const details = () => {
      state.flag = !state.flag;
    };
    // 归档到档案确定
    const submit = () => {
      console.log("确定");
    };
    // 归档到档案取消
    const centerDialogVisible = () => {
      state.flag = false;
    };
    // tabel请求数据
    const repositorylist = () => {};
    // 点击头像打开详情
    const openwin = () => {
      state.flag1 = !state.flag1;
    };
    getLenth();
    return {
      ...refData,
      handleCheckAllChange,
      onLeft,
      onRight,
      getLenth,
      refreshTable,
      handleMoreOperation,
      handleMoreLeave,
      details,
      centerDialogVisible,
      submit,
      Plus,
      Search,
      repositorylist,
      openwin
    };
  }
});
</script>

<style lang='scss' scpoed>
.hunfoldBox {
  width: 90%;
  display: flex;
  height: 170px;
  position: fixed;
  z-index: 1000;
  bottom: 20px;
  left: 95px;
  background: url("~@/assets/images/carbg2.png");
  background-size: 100% 100%;
  .left {
    width: 5%;
    // background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .text {
    width: 90%;
    // background-color: blue;
    overflow: hidden;
    ul {
      display: flex;
      li {
        position: relative;
        margin: 15px 30px;
        width: 100px;
        height: 100px;
        background: url("~@/assets/images/cardbg.png");
        background-size: 100% 100%;
        img {
          width: 90px;
          height: 90px;
          padding: 5px;
        }
        .top {
          position: absolute;
          top: 0px;
          right: 5px;
        }
        .bottom {
          position: absolute;
          bottom: 15px;
          width: 80px;
          background: rgba(0, 0, 0, 0.5);
          text-align: center;
          margin-left: 5px;
        }
      }
    }
  }
  .right {
    width: 5%;
    // background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .footL {
    position: absolute;
    bottom: 10px;
    left: 20px;
    p {
      font-size: 16px;
      color: #a1bddb;
      .el-checkbox {
        color: #a1bddb;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #a1bddb;
      }
    }
  }
  .footR {
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
  .headR {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .dialogx {
  }
  .head {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }
}
</style>